import React, { Component } from 'react';
import InputWithClear from './InputComponents/InputWithClear';
import ErrorMessage from './ErrorMessage';
import LoadingIcon from './LoadingIcon';
import { Paper, Tab, Tabs } from '@mui/material';
import FaIcon from './FaIcon';
import OverWindow from './TabList/OverWindow';
import functionHelper from '../Helpers/functionHelper';
import ButtonFooterContainer from './ButtonFooterContainer';
import FigmaButton from './FigmaButton';
import ButtonTypeEnum from '../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../Enums/ButtonColorsEnum';
import IconPositionEnum from '../Enums/IconPositionEnum';
import { iconsEnabled } from '../Helpers/iconHelper';

export default class GeneralEditPanelBase extends Component {
  static defaultProps = {
    onClose: (doRefresh, result) => {},
    editedItem: null,
    panelDescription: {
      itemType: () => {},
      generalEditComponentDidMountServiceFunction: null,
      processResultFromgeneralEditComponentDidMountServiceFunction: (result, editedItem) => {},
      itemEditedFunction: (editedItem) => {},
      fieldsInEditPanel: [],
      warningCondition: (editedItem) => {},
      warningMessage: '',
      waitForResponseOnSubmit: true,
      clickOnSubmitFunction: (editedItem) => {},
      messageOnSuccess: '',
      isReturningData: false,
      messageOnError: '',
      isErrorPopup: false,
      showEventResultAsListInInfoPopup: false,
      labelForSubmitButton: 'Save',
      tabsInEditPanel: [],
      nameOfTheIdField: 'Id',
      headerForEditPanel: 'Edit Item',
      headerForCreatePanel: 'Create Item',
    },
    itemEditedFunction: (editedItem) => {},
    maxWidth: 800,
    minHeight: 400,
    errorCode: 'GEPB44',
  };

  constructor(props) {
    super(props);
    const tempEditItem = props.editedItem ? { ...props.editedItem } : new this.props.panelDescription.itemType();
    this.state = {
      editedItem: tempEditItem,
      loading: false,
      selectedTab: 0,
    };
  }

  componentDidMount() {
    if (this.props.panelDescription.generalEditComponentDidMountServiceFunction) {
      this.setState({ loading: true });
      this.props.panelDescription
        .generalEditComponentDidMountServiceFunction()
        .then((result) => {
          const tempEditedItem =
            this.props.panelDescription.processResultFromgeneralEditComponentDidMountServiceFunction(
              result,
              this.state.editedItem
            );
          this.setState({
            loading: false,
            editedItem: tempEditedItem,
          });
        })
        .catch((error) => {
          this.setState({ loading: false });
          ErrorMessage.SetErrorMessage(`GEPB49 - ${this.props.errorCode}`);
        });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.editedItem !== prevProps.editedItem) {
      this.setState({
        editedItem: { ...this.props.editedItem },
        loading: true,
      });
      window.setTimeout(() => this.setState({ loading: false }), 1000);
    }
  }

  changeOfEditedItem(fieldName, newValue) {
    this.applyEditedItemChanges([{ fieldName, newValue }]);
  }

  changeOfEditedMultipItem(inputData) {
    this.applyEditedItemChanges(inputData);
  }

  // Applies one or more field changes to the edited item.
  //
  // The user's edit is committed to state SYNCHRONOUSLY (not behind an `await`): for a controlled
  // <input> the value update must happen inside the same change event, otherwise React resets the
  // caret to the end on the next render — the "typing in the middle jumps to the end" bug. The
  // optional itemEditedFunction hooks (which may asynchronously mutate dependent fields) run
  // afterwards, and only their dependent-field changes are reconciled back into state.
  applyEditedItemChanges(changes) {
    const editedFieldNames = changes.map((c) => c.fieldName);
    const tempEditedItem = { ...this.state.editedItem };
    changes.forEach((c) => (tempEditedItem[c.fieldName] = c.newValue));

    // Commit the user's edit immediately so the input keeps its caret position.
    this.setState({ editedItem: tempEditedItem });

    this.runItemEditedHooks(tempEditedItem, editedFieldNames);
  }

  async runItemEditedHooks(baseItem, editedFieldNames) {
    const before = { ...baseItem };
    const working = { ...baseItem };

    if (this.props.itemEditedFunction) {
      await this.props.itemEditedFunction(working);
    }
    if (this.props.panelDescription.itemEditedFunction) {
      await this.props.panelDescription.itemEditedFunction(working);
    }

    // Reconcile only the dependent fields a hook changed — never the field(s) the user just
    // edited — via a functional update so a newer keystroke is not clobbered by a late hook.
    const changedKeys = Object.keys(working).filter(
      (key) => !editedFieldNames.includes(key) && working[key] !== before[key]
    );
    if (changedKeys.length === 0) {
      return;
    }
    this.setState((prevState) => {
      const nextEditedItem = { ...prevState.editedItem };
      changedKeys.forEach((key) => (nextEditedItem[key] = working[key]));
      return { editedItem: nextEditedItem };
    });
  }

  validityCheckerForTheEntireForm() {
    for (const field of this.props.panelDescription.fieldsInEditPanel) {
      if (
        !(typeof field.hide === 'function' && field.hide(this.state.editedItem) === true) &&
        field.validityChecker &&
        field.validityChecker(this.state.editedItem[field.fieldName], this.state.editedItem) !== ''
      )
        return false;
    }
    return true;
  }

  clickOnSubmitButtonWithValidation() {
    if (this.validityCheckerForTheEntireForm()) {
      if (this.props.panelDescription.warningCondition) {
        if (this.props.panelDescription.warningCondition(this.state.editedItem) === true) {
          ErrorMessage.SetApprove(this.props.panelDescription.warningMessage, () => this.clickOnSubmitInner());
        } else {
          this.clickOnSubmitInner();
        }
      } else {
        this.clickOnSubmitInner();
      }
    } else {
      ErrorMessage.SetErrorMessage('Please, check the fields!');
    }
  }

  clickOnSubmitInner() {
    if (this.props.panelDescription.waitForResponseOnSubmit === false) {
      this.props.panelDescription.clickOnSubmitFunction(this.state.editedItem).catch((error) => {
        ErrorMessage.SetErrorMessage('GEPB87');
      });
      const message = this.props.panelDescription.messageOnSuccess
        ? this.props.panelDescription.messageOnSuccess
        : 'The process has been started. You will get a message about the result in your personal notification repository.';
      ErrorMessage.SetNotification(message);
      this.props.onClose(true);
      return;
    }

    this.setState({
      loading: true,
    });
    this.props.panelDescription
      .clickOnSubmitFunction(this.state.editedItem)
      .then((result) => {
        if (this.props.panelDescription.isReturningData === true) {
          this.props.onClose(true, result);
          return;
        }
        if (result && result.error) {
          const message =
            this.props.panelDescription.messageOnError && this.props.panelDescription.messageOnError.includes('{error}')
              ? this.props.panelDescription.messageOnError.replace('{error}', result.error)
              : `Error on saving the item: ${result.error}`;
          if (this.props.panelDescription.isErrorPopup === true) ErrorMessage.SetWarning(message);
          else ErrorMessage.SetErrorMessage(message);
          this.setState({ loading: false });
          return;
        }
        if (result && result.warning) {
          ErrorMessage.SetWarning(result.warning);
          this.props.onClose(true);
          return;
        }
        if (result.eventResult) {
          if (this.props.panelDescription.showEventResultAsListInInfoPopup) {
            const message = (
              <div>
                Result of process:
                <ul>
                  {result.eventResult.success.map((s) => (
                    <li>{s}</li>
                  ))}
                  {result.eventResult.failure.map((s) => (
                    <li>{s}</li>
                  ))}
                </ul>
              </div>
            );
            ErrorMessage.SetInfo(message);
          } else {
            if (result.eventResult.success && result.eventResult.success.length > 0) {
              const success = (
                <div>
                  {result.eventResult.success.map((s) => (
                    <div>{s}</div>
                  ))}
                </div>
              );
              ErrorMessage.SetNotification(success);
            }
            if (result.eventResult.failure && result.eventResult.failure.length > 0) {
              const failure = (
                <div>
                  {result.eventResult.failure.map((f) => (
                    <div>{f}</div>
                  ))}
                </div>
              );
              ErrorMessage.SetErrorMessage(failure);
            }
          }
        } else {
          const message = result.resultMessage
            ? result.resultMessage
            : this.props.panelDescription.messageOnSuccess
            ? this.props.panelDescription.messageOnSuccess
            : 'The item has been saved successfully.';
          ErrorMessage.SetNotification(message);
        }
        this.props.onClose(true);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage(`Error! ErrorCode: ${this.props.errorCode} - GEPB150`);
        this.setState({ loading: false });
      });
  }

  renderInputField(f) {
    const labeltext = typeof f.label === 'function' ? f.label(this.state.editedItem) : f.label;

    if (typeof f.hide === 'function' && f.hide(this.state.editedItem) === true) return;

    const disabled = typeof f.disabled === 'function' ? f.disabled(this.state.editedItem) : f.disabled;

    const multipleIdFilter = {};
    if (f.idFilterArray) {
      for (const fieldName of f.idFilterArray) {
        multipleIdFilter[fieldName] = this.state.editedItem[fieldName];
      }
    }

    return (
      <div
        className={f.className}
        key={`iwckey${f.fieldName}`}
      >
        <InputWithClear
          fieldName={f.fieldName}
          labelText={labeltext === '' ? f.fieldName : labeltext}
          value={this.state.editedItem[f.fieldName]}
          onChange={(fieldName, newValue) => this.changeOfEditedItem(fieldName, newValue)}
          changeOfEditedMultipItem={(data) => this.changeOfEditedMultipItem(data)}
          type={f.type}
          validityChecker={f.validityChecker}
          selectValues={functionHelper.isFunction(f.options) ? f.options(this.state.editedItem) : f.options}
          disabled={disabled}
          placeholder={f.placeholder}
          editedItem={this.state.editedItem}
          EntityTypeId={f.EntityTypeId}
          EntityId={this.state.editedItem[f.EntityId]}
          idFilter={this.state.editedItem[f.idFilter]}
          multipleIdFilter={multipleIdFilter}
          roleKey={f.roleKey}
          numberOfRows={f.numberOfRows}
          isInOneRow={f.isInOneRow}
          IsCheckBoxEnabled={f.IsCheckBoxEnabled}
          getCheckBoxFieldsObject={() => this.state.editedItem}
          separatorCharacter={f.separatorCharacter}
          lookupItemId={f.lookupItemId}
          fileTemplateFunction={f.fileTemplateFunction}
        />
      </div>
    );
  }

  renderButtons() {
    return (
      <ButtonFooterContainer>
        <div className='col-6 text-center'>
          <FigmaButton
            className='applySurveyPanelButton'
            label='Cancel'
            submit={true}
            iconName={`fa-solid fa-upload${this.state.saving ? ' fa-spin' : ''}`}
            disabled={this.state.loading}
            type={ButtonTypeEnum.ExtraLargeNormal}
            color={ButtonColorsEnum.Destruct}
            iconPosition={IconPositionEnum.Left}
            onClick={this.props.onClose}
          />
        </div>
        <div className='col-6 text-center'>
          <FigmaButton
            className='applySurveyPanelButton'
            label={this.props.panelDescription.labelForSubmitButton}
            submit={true}
            iconName='fa-solid fa-save'
            disabled={this.state.loading || !this.validityCheckerForTheEntireForm()}
            type={ButtonTypeEnum.ExtraLargeNormal}
            color={ButtonColorsEnum.Secondary}
            iconPosition={IconPositionEnum.Left}
          />
        </div>
      </ButtonFooterContainer>
    );
  }

  handleTabChange(event, newValue) {
    this.setState({ selectedTab: newValue });
  }

  getClassNameForTab(tab) {
    for (const field of this.props.panelDescription.fieldsInEditPanel) {
      if (
        field.hasOwnProperty('tab') &&
        field.tab === tab.id &&
        field.hasOwnProperty('validityChecker') &&
        field.validityChecker(this.state.editedItem[field.fieldName], this.state.editedItem) !== ''
      )
        return 'bg-warning';
    }
    return '';
  }

  renderTabLabels() {
    const tabLabels = [];
    this.props.panelDescription.tabsInEditPanel.forEach((tab, index) => {
      tabLabels.push(
        <Tab
          className={this.getClassNameForTab(tab)}
          value={index}
          label={
            <>
              {tab.icon && iconsEnabled() && <FaIcon iconName={tab.icon} />} {tab.label}
            </>
          }
          key={`tabkey${index}`}
        />
      );
    });
    return tabLabels;
  }

  renderTabs() {
    if (!this.props.panelDescription.tabsInEditPanel) return null;
    return (
      <Tabs
        value={this.state.selectedTab}
        onChange={this.handleTabChange.bind(this)}
        indicatorColor='primary'
        textColor='primary'
        //centered
        variant='scrollable'
        scrollButtons='auto'
      >
        {this.renderTabLabels()}
      </Tabs>
    );
  }

  renderForm() {
    return (
      !this.state.loading && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            this.clickOnSubmitButtonWithValidation();
          }}
        >
          <div className='container-fluid'>
            <div className='row'>
              {this.renderTabs()}
              {this.props.panelDescription.tabsInEditPanel ? (
                <Paper
                  elevation={6}
                  className='border p-1 m-1'
                >
                  <div className='container-fluid'>
                    <div className='row'>
                      {this.props.panelDescription.fieldsInEditPanel
                        .filter(
                          (f) =>
                            !!f.tab && f.tab === this.props.panelDescription.tabsInEditPanel[this.state.selectedTab].id
                        )
                        .map((f) => this.renderInputField(f))}
                    </div>
                  </div>
                </Paper>
              ) : null}
              {this.props.panelDescription.fieldsInEditPanel
                .filter((f) => !f.tab || !this.props.panelDescription.tabsInEditPanel)
                .map((f) => this.renderInputField(f))}
            </div>
            {this.renderButtons()}
          </div>
        </form>
      )
    );
  }

  GetHeaderText() {
    return this.props.editedItem
      ? this.props.panelDescription.nameOfTheIdField
        ? `${this.props.panelDescription.headerForEditPanel} (${
            this.props.editedItem[this.props.panelDescription.nameOfTheIdField]
          })`
        : this.props.panelDescription.headerForEditPanel
      : this.props.panelDescription.headerForCreatePanel;
  }

  render() {
    const content = (
      <>
        <LoadingIcon loading={this.state.loading} />
        {this.renderForm()}
      </>
    );

    const title =
      this.props.editedItem && this.props.editedItem[this.props.panelDescription.nameOfTheIdField]
        ? this.props.panelDescription.nameOfTheIdField
          ? `${this.props.panelDescription.headerForEditPanel} (${
              this.props.editedItem[this.props.panelDescription.nameOfTheIdField]
            })`
          : this.props.panelDescription.headerForEditPanel
        : this.props.panelDescription.headerForCreatePanel;

    return (
      <OverWindow
        title={title}
        clickOnCancel={this.props.onClose}
        closeOnClickOutside={false}
        maxWidth={this.props.maxWidth}
        minHeight={this.props.minHeight}
        zIndex={1050}
        verticalScroll={false}
      >
        <div className='container-fluid verticalScrollForSearch height50vh'>{content}</div>
      </OverWindow>
    );
  }
}
